<template>
  <div class="card card-plain">
    <div role="tab" id="headingOne" class="card-header card-header-construction">
      <a data-toggle="collapse"
         data-parent="#accordion"
         :href="`#${itemId}`"
         @click.prevent="activate"
         :aria-expanded="active"
         :aria-controls="`content-${itemId}`">
        <div class="row">
          <div class="col">
            <p style="font-size: 1.1em;"><b><slot name="title">{{title}}</slot></b></p>
          </div>
          <div class="col ml-3">
           <el-progress :text-inside="true" :stroke-width="20" :percentage="parseInt((parseInt(completedParcoursCount) / parseInt(parcoursCount) * 100).toFixed(0))"  style="max-width: 200px;" class="mt-1">
            </el-progress>
          </div>
          <div class="col text-right">
            <span style="font-size: 0.9em;"><slot name="title">{{completedParcoursCount}}</slot> / <slot name="title">{{parcoursCount}}</slot></span>
          </div>
          <div class="col-1 text-right">
            <i class="nc-icon nc-minimal-down"></i>
          </div>
        </div>


        
        
      </a>
    </div>
    <collapse-transition :duration="animationDuration">
      <div v-show="active"
           :id="`content-${itemId}`"
           role="tabpanel"
           :aria-labelledby="title"
           class="collapsed">
        <div class="card-body">
          <slot></slot>
        </div>
      </div>
    </collapse-transition>
  </div>
</template>
<script>
  import {CollapseTransition} from 'vue2-transitions';
  import { Progress } from "element-ui";

  export default {
    name: 'collapse-item-construction',
    components: {
      CollapseTransition,
      [Progress.name]: Progress,
    },
    props: {
      title: {
        type: String,
        default: '',
        description: 'Collapse item title (text)'
      },
      completedParcoursCount: {
        type: Number,
        default: '',
        description: 'Collapse item title (text)'
      },
      parcoursCount: {
        type: Number,
        default: '',
        description: 'Collapse item title (text)'
      },
      id: String
    },
    inject: {
      animationDuration: {
        default: 250
      },
      multipleActive: {
        default: false
      },
      addItem: {
        default: () => {}
      },
      removeItem: {
        default: () => {}
      },
      deactivateAll: {
        default: () => {}
      }
    },
    computed: {
      itemId() {
        return this.id || this.title
      }
    },
    data() {
      return {
        active: false
      }
    },
    methods: {
      activate(){
        let wasActive = this.active;
        if(!this.multipleActive){
          this.deactivateAll();
        }
        this.active = !wasActive;
      }
    },
    mounted() {
      this.addItem(this)
    },
    destroyed() {
      if (this.$el && this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el)
      }
      this.removeItem(this)
    }
  }
</script>
<style >
.card-header-construction {
  padding-bottom: 0px !important;
}
</style>
